export default "__VITE_ASSET__DOxh5gZi__"